// @flow

import React, { type ComponentType } from 'react';

type LoginFormWrapperProps = {
  accountName: ?string,
  FormComponent: ComponentType<any>,
  invitationCode: ?string,
  invitationEmail: ?string,
  teamLogoUrl: ?string,
  isInviting: boolean,
  matchesMediaQuery: {
    narrow: boolean,
  },
};

const LoginFormWrapper = ({
  FormComponent,
  ...props
}: LoginFormWrapperProps) => <FormComponent {...props} />;

export default LoginFormWrapper;
